var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiPlanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67016 0.828125L12.1947 11.5503L19.5652 14.4833L12.1947 18.1769L9.67016 27.8281L7.14564 18.1769L0 14.4833L7.14564 11.5503L9.67016 0.828125Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4402 2.00195L19.2817 5.26522L21.7385 6.15788L19.2817 7.28202L18.4402 10.2193L17.5987 7.28202L15.2168 6.15788L17.5987 5.26522L18.4402 2.00195Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7019 17.2627L22.5434 20.526L25.0003 21.4186L22.5434 22.5428L21.7019 25.4801L20.8604 22.5428L18.4785 21.4186L20.8604 20.526L21.7019 17.2627Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPlanner);
export default __webpack_public_path__ + "static/media/ai-planner.457aadfca660de2b9473c2a0c7fd2725.svg";
export { ForwardRef as ReactComponent };